// extracted by mini-css-extract-plugin
export default {"ag-styles":"k_t","policyPage":"k_bc","introduction":"k_bd","policyList":"k_bf","settingsButton":"k_bg"};